import { createSlice } from '@reduxjs/toolkit';
import {
  editClientToDoBuilder,
  createTodDoForClientBuilder,
  createTodDoTemplateBuilder,
  createTodDoTemplateForClientBuilder,
  deleteToDoForClientBuilder,
  getClientToDosBuilder,
  getToDoTemplatesBuilder,
  getToDoTemplateByIdBuilder,
  editToDoTemplateBuilder,
  deleteToDoTemplateBuilder,
} from './builder';

const initialState = {
  getClientToDosPending: false,
  createToDoForClientPending: false,
  deleteToDoForClientPending: false,
  createToDoTemplatePending: false,
  getToDoTemplatesPending: false,
  createToDoTemplateForClientPending: false,
  editClientToDoPending: false,
  getToDoTemplateByIdPending: false,
  editTemplateToDoPending: false,
  deleteToDoTemplatePending: false,

  clientToDos: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
  },

  toDoTemplates: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
    perPage: 0,
  },

  selectedTemplate: {
    data: {},
    toDos: [],
  },
};
export const toDoSlice = createSlice({
  name: 'toDosInfo',
  initialState,
  reducers: {
    resetSelectedTemplate(state) {
      state.selectedTemplate = { data: {}, toDos: [] };
    },
  },
  extraReducers: builder => {
    getClientToDosBuilder(builder);
    createTodDoForClientBuilder(builder);
    deleteToDoForClientBuilder(builder);
    createTodDoTemplateBuilder(builder);
    getToDoTemplatesBuilder(builder);
    createTodDoTemplateForClientBuilder(builder);
    editClientToDoBuilder(builder);
    getToDoTemplateByIdBuilder(builder);
    editToDoTemplateBuilder(builder);
    deleteToDoTemplateBuilder(builder);
    builder.addCase('logout', () => initialState);
  },
});

export const selectClientToDos = state => state.toDosInfo.clientToDos;
export const selectGetClientToDosPending = state => state.toDosInfo.getClientToDosPending;
export const selectCreateToDoForClientPending = state => state.toDosInfo.createToDoForClientPending;
export const selectDeleteToDoForClientPending = state => state.toDosInfo.deleteToDoForClientPending;
export const selectToDoTemplates = state => state.toDosInfo.toDoTemplates;
export const selectGetToDoTemplatesPending = state => state.toDosInfo.getToDoTemplatesPending;
export const selectCreateToDoTemplatePending = state => state.toDosInfo.createToDoTemplatePending;
export const selectCreateToDoTemplateForClientPending = state => state.toDosInfo.createToDoTemplateForClientPending;
export const selectEditClientToDoPending = state => state.toDosInfo.editClientToDoPending;
export const selectGetToDoTemplateByIdPending = state => state.toDosInfo.getToDoTemplateByIdPending;
export const selectSelectedTemplate = state => state.toDosInfo.selectedTemplate;
export const selectEditTemplateToDoPending = state => state.toDosInfo.editTemplateToDoPending;
export const selectDeleteToDoTemplatePending = state => state.toDosInfo.deleteToDoTemplatePending;

export const { resetSelectedTemplate } = toDoSlice.actions;

export default toDoSlice.reducer;
